import React, { useContext } from 'react';
import Scrollbars from 'react-custom-scrollbars';
import { useQuery } from 'react-query';
import { getBookDetailsData } from '../../NecttosComp/APICaller/ApiServices';
import { Main, Header, Body } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';

function ViewBookDetails({ onCloseModal, stockId }) {
	const { data } = useQuery(['stockSataIndex'], getBookDetailsData(stockId));
	const bookDetails = data;

	const DetailCard = ({ label, value }) => {
		if (!value) return null;
		return (
			<div className='shadow-md w-[96%] ml-[2%] my-4 p-4 bg-slate-100  dark:bg-slate-400  rounded-xl'>
				<label className='text-gray-600 text-sm font-medium'>{label}</label>
				<div className='text-[rgb(11,1,68)] text-lg font-semibold mt-1'>{value}</div>
			</div>
		);
	};

	return (
		<Main className='bg-white dark:bg-slate-400' title='View Book Details' height='100%' width='100%'>
			<Header className='flex justify-between items-center h-[60px] bg-[rgb(6,5,66)] px-6 text-white rounded-t-2xl'>
				<h2 className='text-4xl font-semibold dark:text-slate-100'>Details of Book</h2>
				<Button type='close' onClick={onCloseModal}>
					Close
				</Button>
			</Header>

			<Body height='100%' className='bg-slate-100'>
				<Scrollbars className='w-full h-[70vh] px-2' autoHide>
					<div className='flex flex-col md:flex-row items-center md:items-start justify-center gap-6 my-4 px-4'>
						<img src={bookDetails?.image} alt='Book cover' className='w-[180px] h-[250px] object-cover rounded-lg shadow-md bg-[#012536]' />
						<div className='w-full md:w-[60%]'>
							<DetailCard label='Title of the Book' value={bookDetails?.nameOfBook} />

							<DetailCard label='Name of Authors & Year' value={[bookDetails?.nameOfAuthor && `${bookDetails?.nameOfAuthor} [${bookDetails?.authorType}]`, bookDetails?.nameOfAuthor2 && `${bookDetails?.nameOfAuthor2} [${bookDetails?.authorType2}]`, bookDetails?.nameOfAuthor3 && `${bookDetails?.nameOfAuthor3} [${bookDetails?.authorType3}]`, bookDetails?.yearOfPublication && `Year: ${bookDetails?.yearOfPublication}`].filter(Boolean).join(', ')} />
						</div>
					</div>

					<div className='grid grid-cols-1 md:grid-cols-2 gap-x-4 '>
						<DetailCard label='Call Number' value={bookDetails?.callNo} />
						<DetailCard label='Category By' value={bookDetails?.category} />
						<DetailCard label='Status' value={bookDetails?.status} />
						<DetailCard label='Accession Number' value={bookDetails?.accessionNumber} />

						<DetailCard label='Name of Publication' value={bookDetails?.nameOfPublisher} />

						<DetailCard label='Place of Publication' value={bookDetails?.placeOfPublication} />
						<DetailCard label='Edition Statement' value={bookDetails?.edition} />

						<DetailCard label='Subject Includes' value={bookDetails?.subject} />

						<DetailCard label='Volume Number' value={bookDetails?.volume} />
						<DetailCard label='Issue Number' value={bookDetails?.issue} />

						<DetailCard label='ISBN' value={bookDetails?.isbn} />

						<DetailCard label='Pages' value={bookDetails?.pages} />
						<DetailCard label='Language' value={bookDetails?.language} />

						<DetailCard label='Series' value={bookDetails?.series} />
					
					</div>
					{bookDetails?.contents && (
						<div className='shadow-md w-[96%] ml-[2%] my-4 p-4 bg-slate-100 dark:bg-slate-400 rounded-xl'>
							<label className='text-gray-600 text-sm font-medium'>Contents</label>
							<textarea readOnly className='text-[rgb(11,1,68)] text-base font-normal mt-1 w-full bg-slate-100 dark:bg-slate-400 border-none resize-none focus:outline-none' value={bookDetails?.contents} rows={12} />
						</div>
						
					)}
						<details className='col-span-full mt-2'>
							<summary className='w-fit px-4 py-2 bg-blue-600 text-white rounded-md shadow cursor-pointer hover:bg-blue-700 transition'>Additional Details</summary>

							<div className='grid grid-cols-1 md:grid-cols-2 gap-x-4 mt-4'>
								<DetailCard label='DDC Subject' value={`[${bookDetails?.ddcNumber}] ${bookDetails?.ddcSubject}`} />
								<DetailCard label='Price of the Book' value={`${bookDetails?.price} [${bookDetails?.discount}]`} />
								<DetailCard label='Fund' value={bookDetails?.fund} />
								<DetailCard label='Invoice Number' value={bookDetails?.invoiceNumber} />
								<DetailCard label='Date' value={bookDetails?.date} />
								<DetailCard label='Vendor' value={bookDetails?.vendor} />
							</div>
						</details>
				</Scrollbars>
			</Body>
		</Main>
	);
}

export default ViewBookDetails;
